"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientConfigSecretsSchema = exports.ClientRuntimeEnvSchema = void 0;
const zod_1 = require("zod");
/**
 * Schema for client-side runtime configuration.
 * This is what gets loaded from /env.js in the browser via window.__ENV__
 *
 * Values are nullish because:
 * - In local dev without env.js, they'll be undefined
 * - In deployments without config, they'll be null
 * - Only when explicitly configured will they have string values
 *
 * IMPORTANT: Keep in sync with CLIENT_ENVIRONMENT_FIELDS in clientEnvironmentConfig.ts
 */
exports.ClientRuntimeEnvSchema = zod_1.z.object({
    sentryDsn: zod_1.z.url().nullish(),
    highlightProjectId: zod_1.z.string().nullish(),
});
/**
 * Schema for client configuration from environment variables.
 *
 * Uses uppercase keys (convention) that map to the runtime env schema.
 * Defaults to empty string to ensure keys exist in AWS Secrets Manager
 * (ECS will fail to start if referenced secret keys don't exist).
 *
 * Note: URL validation is not enforced here - validation happens at runtime
 * when the client app loads the configuration.
 *
 * IMPORTANT: Keep in sync with CLIENT_ENVIRONMENT_FIELDS in clientEnvironmentConfig.ts
 */
exports.ClientConfigSecretsSchema = zod_1.z.object({
    SENTRY_DSN: zod_1.z.string().default(''),
    HIGHLIGHT_PROJECT_ID: zod_1.z.string().default(''),
});
//# sourceMappingURL=clientEnvironmentSchema.js.map